<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  async created() {
    if (this.$route.query?.state) {
      const provider = JSON.parse(this.$route.query?.state)

      this.$auth
        .oauth2('google', {
          url: '/auth/google',
          code: true,
          data: {
            code: this.$route.query.code,
          },
          state: this.$route.query.state,
        })
        .then(
          data => {},
          error => this.handleErrors(error.response.data)
        )
    } else if (this.$route.query.token) {
      this.$auth.token(null, this.$route.query.token, false)
      await this.$auth.fetch()
      if (this.$auth.check()) this.$router.push({ name: 'likesIndex' })
    } else {
      this.handleErrors(this.$route.query)
    }
  },

  render: () => null,

  methods: {
    handleErrors,
  },

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
function handleErrors(errors) {
  Object.entries(errors).forEach(([key, value]) => {
    if (key != 'errors') {
      this.$notyf.error({ message: `${value}`, duration: 6000 })
    }
  })

  this.$auth.logout()
}
</script>
